import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {RELEVANT_PROCESS_FRAGMENT} from 'relevant-items/RelevantItemsSection';

export const CONTAINER_RELEVANT_ITEMS_FRAGMENT = gql`
  fragment ContainerRelevantItemsGraphQL on RelevantItemsNode {
    tagged {
      ... on FolderItemInterface {
        id
        name
        folder {
          id
          source {
            name
          }
        }
        modifiedAt
      }
      ... on StageEntryNode {
        id
        name
        modifiedAt
      }
      ... on EntryLikeDocumentNode {
        id
        name
        modifiedAt
        parent {
          ... on WorksheetNode {
            id
            folder {
              id
              source {
                name
              }
            }
          }
        }
        parentId
      }
    }
    taggedStorables {
      id
      name
      modifiedAt
      source {
        name
      }
    }
    filesMentioning {
      ... on FolderItemInterface {
        id
        name
        modifiedAt
        folder {
          id
          source {
            name
          }
        }
      }
      ... on StageEntryNode {
        id
        name
        modifiedAt
      }
      ... on EntryLikeDocumentNode {
        id
        name
        modifiedAt
        parent {
          ... on WorksheetNode {
            id
            folder {
              id
              source {
                name
              }
            }
          }
        }
        parentId
      }
    }
    processTasks {
      id
      name
      process {
        ...RelevantProcessGraphQL
      }
    }
    processOutputs {
      id
      name
      process {
        ...RelevantProcessGraphQL
      }
    }
  }
  ${RELEVANT_PROCESS_FRAGMENT}
`;

export const CONTAINER_RELEVANT_ITEMS_QUERY = gql`
  query ContainerRelevantItemsQuery($containerId: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    container(id: $containerId) {
      ... on ContainerNode {
        id
        relevantItems {
          ...ContainerRelevantItemsGraphQL
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${CONTAINER_RELEVANT_ITEMS_FRAGMENT}
`;
